module.exports = __webpack_public_path__ + "img/businesstoday.6a442d63.svg";